export const COMPLETE_MERCHANT_APPLICATION = gql`
    mutation CompleteMerchantApplication($input: CompleteMerchantApplicationInput) {
        completeMerchantApplication(input: $input) {
            id
            status
            partnerId
            serviceRequirements
            merchantInformation
            outletInformation
            businessInformation
            supportingDocuments
        }
    }
`;
